/**
 * Pagination helper class.
 */
class Paginator<Item> {
  private prevPageItemId: string | number | null;
  private nextPageItemId: string | number | null;
  private source: any;

  /**
   * Array of elements on current page.
   */
  public readonly items: Item[];

  /**
   * @internal
   */
  constructor(items: any, source: any, prevItemId: string | number | null = null, nextItemId: string | number | null = null) {
    this.items = items;
    this.source = source;
    this.prevPageItemId = prevItemId;
    this.nextPageItemId = nextItemId;
  }

  /**
   * Request next page.
   * Does not modify existing object.
   */
  async nextPage(): Promise<Paginator<Item>> {
    if (!this.hasNextPage) {
      throw new Error('No next page');
    }

    return this.source({ nextPageItemId: this.nextPageItemId });
  }

  /**
   * Request previous page.
   * Does not modify existing object.
   */
  async prevPage(): Promise<Paginator<Item>> {
    if (!this.hasPrevPage) {
      throw new Error('No previous page');
    }

    return this.source({ prevPageItemId: this.prevPageItemId });
  }

  /**
   * Indicates the existence of the next page.
   */
  get hasNextPage(): boolean {
    return this.nextPageItemId !== null;
  }

  /**
   * Indicates the existence of the previous page.
   */
  get hasPrevPage(): boolean {
    return this.prevPageItemId !== null;
  }
}

export { Paginator };
